/** Browser-side crash reporting: failures on visitors' devices reach the server log. */

let sent = 0;

/** Sends a crash to the server log. Best effort, a few per page load, never throws. */
export function reportClientError(error: unknown, source: string) {
  if (sent >= 5) return;
  sent++;
  try {
    const e = error instanceof Error ? error : new Error(String(error));
    void fetch("/api/client-errors", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: `${e.name}: ${e.message}`.slice(0, 500),
        stack: (e.stack || "").slice(0, 4000),
        path: location.pathname.slice(0, 300),
        source: source.slice(0, 40),
      }),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    /* reporting must never break the page */
  }
}

export function installErrorReporting() {
  window.addEventListener("error", (ev) => reportClientError(ev.error ?? ev.message, "window.error"));
  window.addEventListener("unhandledrejection", (ev) => reportClientError(ev.reason, "unhandledrejection"));
}
